var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6913",
    "data-name": "Group 6913",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.687,
    height: 16.222,
    viewBox: "0 0 29.687 16.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_955",
    "data-name": "Rectangle 955",
    width: 29.687,
    height: 16.222,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6912",
    "data-name": "Group 6912",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4264",
    "data-name": "Path 4264",
    d: "M26.851,0h0a2.838,2.838,0,0,0-2.484,4.21L20.04,8.58a2.825,2.825,0,0,0-3.274.433L13.529,7.107a2.908,2.908,0,0,0,.091-.692A2.839,2.839,0,1,0,8.209,7.607L4.374,10.971h0a2.846,2.846,0,1,0,1.058,1.206L9.261,8.81a2.819,2.819,0,0,0,3.455-.326l3.239,1.906h0a2.743,2.743,0,0,0-.087.688A2.838,2.838,0,1,0,21.18,9.7L25.5,5.335v0A2.838,2.838,0,1,0,26.851,0M2.846,14.614h0a1.239,1.239,0,1,1,1.235-1.238,1.239,1.239,0,0,1-1.235,1.238m7.923-6.953h0a1.237,1.237,0,1,1,1.238-1.238,1.235,1.235,0,0,1-1.238,1.238M18.7,12.324h0a1.237,1.237,0,1,1,1.238-1.235A1.236,1.236,0,0,1,18.7,12.324m8.147-8.24h0A1.239,1.239,0,1,1,28.08,2.847a1.238,1.238,0,0,1-1.238,1.238",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.517b49b51f499597a8e19ddd87836293.svg";
export { ForwardRef as ReactComponent };